<onsip-header-main>
  <onsip-header-page-title> {{ "ONSIP_I18N.ADD_RECORDING" | translate }} </onsip-header-page-title>
</onsip-header-main>
<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form [formGroup]="form" (ngSubmit)="submitForm()">
    <div class="wrapper setup onsip-grid-placement">
      <div class="first-column">
        <section class="with-mat-form-field">
          <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.RECORDING_NAME" | translate }}</div>
          <div class="value mat-body-2">
            <mat-form-field appearance="outline">
              <input formControlName="name" matInput type="text" />
              <mat-error>{{
                getGenericRequiredError(form.controls.name, "ONSIP_I18N.NAME" | translate)
              }}</mat-error>
            </mat-form-field>
          </div>
        </section>
      </div>
      <div class="second-column">
        <section>
          <div class="m-b-12 mat-body-1">
            {{ "ONSIP_I18N.CREATE_RECORDING" | translate }}
          </div>

          <div>
            {{ "ONSIP_I18N.TO_CREATE_A_RECORDING" | translate }}
          </div>

          <div class="m-b-28">
            {{ "ONSIP_I18N.CLICK_THE_MICROPHONE_TO_START_RECORD" | translate }}
          </div>

          <div>
            {{ "ONSIP_I18N.TO_UPLOAD_A_RECORDING" | translate }}
          </div>

          <div>
            {{ "ONSIP_I18N.UPLOAD_A_PRE_RECORDED_WAV_FILE" | translate }}
          </div>
        </section>
      </div>

      <div class="third-column">
        <section>
          <div class="mat-body-1 m-b-12">Add a recording</div>

          <onsip-togglable-recorder
            #recordingControl
            formControlName="record"
            entityLabel="recording"
            [hasSelect]="false"
            [defaultType]="recordingType"
            (recordingTypeChange)="recordingType = $event"
          >
          </onsip-togglable-recorder>
        </section>
      </div>
    </div>
    <div class="page-view-controls">
      <button mat-button class="toggle-button" color="primary" type="button" (click)="onCancel()">
        {{ "ONSIP_I18N.CANCEL" | translate }}
      </button>
      <button mat-flat-button class="toggle-button" color="primary" type="submit">
        {{ "ONSIP_I18N.ADD" | translate }}
      </button>
    </div>
  </form>
</onsip-loading-container>
